// extracted by mini-css-extract-plugin
export var avatar = "_qo-3";
export var avatarContainer = "_qo-2";
export var avatarSpacer = "_qo-5";
export var avatarSpacerContainer = "_qo-4";
export var avatarStackContainer = "_qo-1";
export var bubble = "_qo-0";
export var remainderBubble = "_qo-6";